import { useDispatch, useSelector } from 'react-redux'
import { sify } from 'chinese-conv'
import _ from 'lodash'

import { Card } from '@mui/material'

import { constants } from '../../Constants/constants'
import {
  setQueueTemplate,
  setQueueTemplateTableTypeGroupedSection,
} from '../../actions/queueTemplateAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempCustomCheckBox } from '../../Component/Custom/TempCustomCheckBox'
import { getContent } from '../../Component/EditCreateDisplay/EditUtil'

const resource = 'groupedSection'

export const QueueTemplateGroupedSection = () => {
  const dispatch = useDispatch()
  const savedQueueTemplate = useSelector((state) => state.queueTemplate.ui.queueTemplate)
  const savedGroupedSection = useSelector((state) => state.queueTemplate.ui.groupedSection)

  const tempQueueTemplateCreateList = [
    {
      className: 'edit-create-input',
      variant: constants.STYLE.VARIANT.STANDARD,
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSection' },
      value: savedGroupedSection?.groupedSection?.groupedSection,
      disabled: true,
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSectionEnLabel' },
      value: savedGroupedSection?.groupedSection?.label?.en,
      name: 'groupedSection?.label?.en',
      custom: true,
      customName: { resource: resource, key: 'isAutoTranslateGroupedSectionLabel' },
      customValue: savedGroupedSection.disableGroupedSection,
      isEndOfLine: false,
      multiline: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSectionTcLabel' },
      value: savedGroupedSection?.groupedSection?.label?.['zh-HK'],
      name: 'groupedSection.label.zh-HK',
      isEndOfLine: false,
      multiline: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSectionScLabel' },
      value: savedGroupedSection?.groupedSection?.label?.['zh-CN'],
      name: 'groupedSection.label.zh-CN',
      isEndOfLine: true,
      disabled: savedGroupedSection.disableGroupedSection,
      multiline: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSectionEnDescription' },
      value: savedGroupedSection?.groupedSection?.description?.en,
      name: 'groupedSection.description.en',
      custom: true,
      customName: { resource: resource, key: 'isAutoTranslateGroupedSectionDescription' },
      customValue: savedGroupedSection.disableGroupedSectionDescription,
      isEndOfLine: false,
      multiline: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSectionTcDescription' },
      value: savedGroupedSection?.groupedSection?.description?.['zh-HK'],
      name: 'groupedSection.description.zh-HK',
      isEndOfLine: false,
      multiline: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'groupedSectionScDescription' },
      value: savedGroupedSection?.groupedSection?.description?.['zh-CN'],
      name: 'groupedSection.description.zh-CN',
      isEndOfLine: true,
      disabled: savedGroupedSection.disableGroupedSectionDescription,
      multiline: true,
    },
  ]

  const content = [
    {
      tab: (
        <>
          <Card className="card-wrapper">
            {tempQueueTemplateCreateList.map((inputSetting, index) => {
              let content = getContent(inputSetting, index, onChangeInput)
              return (
                <div className="edit-display-wrapper" key={index}>
                  {inputSetting.custom && (
                    <TempCustomCheckBox
                      className="customize-btn"
                      value={inputSetting.customValue}
                      customName={inputSetting.customName}
                      onSelectCheckbox={onSelectCheckbox}
                    />
                  )}
                  {content}
                  {inputSetting.isEndOfLine && <div></div>}
                </div>
              )
            })}
          </Card>
        </>
      ),
      btn: false,
    },
  ]

  function onSelectCheckbox(value, customName, index) {
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newGroupedSection = _.cloneDeep(savedGroupedSection)
    console.log('customName', customName, value)
    switch (customName.key) {
      case 'isAutoTranslateGroupedSectionLabel':
        newGroupedSection.disableGroupedSection = value
        if (value) {
          newGroupedSection.groupedSection.label['zh-CN'] = newGroupedSection?.groupedSection?.label?.['zh-HK']
            ? sify(newGroupedSection?.groupedSection?.label?.['zh-HK'])
            : newGroupedSection?.groupedSection?.label?.['zh-HK']
        }
        break
      case 'isAutoTranslateGroupedSectionDescription':
        newGroupedSection.disableGroupedSectionDescription = value
        if (value) {
          newGroupedSection.groupedSection.description['zh-CN'] = newGroupedSection?.groupedSection?.description?.['zh-HK']
            ? sify(newGroupedSection?.groupedSection?.description?.['zh-HK'])
            : newGroupedSection?.groupedSection?.description?.['zh-HK']
        }
        break
      default:
    }
    const tempTimeSectionIndex = newGroupedSection.currentTimeSectionIndex
    tempQueueTemplate[tempTimeSectionIndex].tableTypeList.forEach((tableType) => {
      if (tableType.groupedSection.groupedSection === newGroupedSection?.groupedSection?.groupedSection) {
        tableType.groupedSection.groupedSection = newGroupedSection?.groupedSection?.groupedSection
        tableType.groupedSection.description.en = newGroupedSection?.groupedSection?.description?.en
        tableType.groupedSection.label.en = newGroupedSection?.groupedSection?.label?.en
        tableType.groupedSection.description['zh-CN'] = newGroupedSection?.groupedSection?.description?.['zh-CN']
        tableType.groupedSection.label['zh-CN'] = newGroupedSection?.groupedSection?.label?.['zh-CN']
        tableType.groupedSection.description['zh-HK'] = newGroupedSection?.groupedSection?.description?.['zh-HK']
        tableType.groupedSection.label['zh-HK'] = newGroupedSection?.groupedSection?.label?.['zh-HK']
      }
    })

    dispatch(setQueueTemplateTableTypeGroupedSection(newGroupedSection))
    dispatch(setQueueTemplate(tempQueueTemplate))

  }

  function onChangeInput(name, e, index) {
    const tempQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newGroupedSection = _.cloneDeep(savedGroupedSection)

    // helper to set nested path or plain key
    const setField = (path, val) => {
      if (String(path).includes('.')) {
        _.set(newGroupedSection, path, val)
      } else {
        newGroupedSection[path] = val
      }
    }

    // when editing a Traditional Chinese field, optionally update Simplified Chinese sibling
    const maybeAutoTranslate = (path, val) => {
      const tcMatch = path.match(/\.(zh-HK|zh-TW)$/)
      if (!tcMatch) return
      const scPath = path.replace(/\.(zh-HK|zh-TW)$/, '.zh-CN')
      if (newGroupedSection.disableGroupedSection) {
        _.set(newGroupedSection, scPath, val ? sify(val) : null)
      }
    }

    switch (name) {
      case 'groupedSection.label.zh-HK':
        setField(name, e)
        if (newGroupedSection.disableGroupedSection) {
          _.set(newGroupedSection, 'groupedSection.label.zh-CN', newGroupedSection?.groupedSection?.label?.['zh-HK'] ? sify(newGroupedSection?.groupedSection?.label?.['zh-HK']) : newGroupedSection?.groupedSection?.label?.['zh-HK'])
        }
        break
      case 'groupedSection.description.zh-HK':
        setField(name, e)
        if (newGroupedSection.disableGroupedSectionDescription) {
          _.set(newGroupedSection, 'groupedSection.description.zh-CN', newGroupedSection?.groupedSection?.description?.['zh-HK'] ? sify(newGroupedSection?.groupedSection?.description?.['zh-HK']) : newGroupedSection?.groupedSection?.description?.['zh-HK'])
        }
        break
      default:
        setField(name, e)
    }

    const tempTimeSectionIndex = newGroupedSection.currentTimeSectionIndex
    tempQueueTemplate[tempTimeSectionIndex].tableTypeList.forEach((tableType) => {
      if (tableType.groupedSection === newGroupedSection.groupedSection) {
        tableType.groupedSection.groupedSection = newGroupedSection?.groupedSection?.groupedSection
        tableType.groupedSection.description.en = newGroupedSection?.groupedSection?.description?.en
        tableType.groupedSection.label.en = newGroupedSection?.groupedSection?.label?.en
        tableType.groupedSection.description['zh-CN'] = newGroupedSection?.groupedSection?.description?.['zh-CN']
        tableType.groupedSection.label['zh-CN'] = newGroupedSection?.groupedSection?.label?.['zh-CN']
        tableType.groupedSection.description['zh-HK'] = newGroupedSection?.groupedSection?.description?.['zh-HK']
        tableType.groupedSection.label['zh-HK'] = newGroupedSection?.groupedSection?.label?.['zh-HK']
      }
    })

    // notify changes
    dispatch(setQueueTemplateTableTypeGroupedSection(newGroupedSection))
    dispatch(setQueueTemplate(tempQueueTemplate))
    dispatch(setQueueTemplateTableTypeGroupedSection(newGroupedSection))
  }

  return (
    <div>
      <EditCreateDisplay
        code={savedGroupedSection && savedGroupedSection?.groupedSection?.groupedSection ? savedGroupedSection?.groupedSection?.groupedSection : ''}
        resource={resource}
        tabs={false}
        content={content}
        onChangeInput={onChangeInput}
        display={'edit'}
      />
    </div>
  )
}
